module.exports = __webpack_public_path__ + "static/ob-db2614f24b741b945f46ceca8274ca66.jpg";